export const TX_KEY_STORE_SET = 'TX_KEY_STORE_SET';
export const TX_KEY_STORE_PASSWORD_SET = 'TX_KEY_STORE_PASSWORD_SET';
export const KEYSTORE_MODAL_SHOW = 'KEYSTORE_MODAL_SHOW';
export const KEYSTORE_MODAL_HIDE = 'KEYSTORE_MODAL_HIDE';